var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowLeftS(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h20v20H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9H6.26l3.88-3.23a1 1 0 00-1.28-1.54l-6 5a.81.81 0 00-.17.23l-.07.09a1 1 0 000 .82l.07.09a.81.81 0 00.17.23l6 5a1 1 0 00.64.31 1 1 0 00.77-.36 1 1 0 00-.13-1.41L6.26 11H16.5a1 1 0 000-2z"
  })));
}

export default SvgIconArrowLeftS;